import { toast } from 'vue3-toastify'

import { fetchMaintenance } from '@/services/ms'
import { useCache } from '@/stores/cache.js'

const VERSION_CHECK_URL = '/version.json'

let updateListenerAttached = false
let updateHandled = false

export const useServiceWorkerVersionWatcher = () => {
  const checkForNewVersion = async () => {
    if (import.meta.env.VITE_APP_URL.includes('stag')) return
    try {
      const response = await fetch(`${VERSION_CHECK_URL}?t=${Date.now()}`, {
        cache: 'no-store'
      })

      const data = await response.json()
      const currentVersion = import.meta.env.VITE_APP_VERSION
      const isCritical = data.critical
      const newVersion = data.version

      if (newVersion !== currentVersion) {
        const registration = await navigator.serviceWorker.getRegistration()
        if (registration == null) return

        if (!updateListenerAttached) {
          updateListenerAttached = true

          registration.addEventListener('updatefound', () => {
            const newSW = registration.installing

            newSW?.addEventListener('statechange', () => {
              if (newSW.state === 'installed' && !updateHandled) {
                updateHandled = true
                newSW.postMessage({ type: 'SKIP_WAITING' })

                if (isCritical) {
                  navigator.serviceWorker.addEventListener('controllerchange', () => {
                    window.location.reload()
                  })
                } else {
                  toast('Nova versão disponível.</br><u>Clique aqui para atualizar.</u>', {
                    theme: 'auto',
                    type: 'info',
                    autoClose: false,
                    dangerouslyHTMLString: true,
                    onClick: () => window.location.reload()
                  })
                }

                setTimeout(() => {
                  updateListenerAttached = false
                  updateHandled = false
                }, 5000)
              }
            })
          })
        }

        await registration.update()
      }
    } catch (error) {
      console.warn('[checkForNewVersion] Falha ao verificar nova versão:', error)
    }
  }

  const checkIfUnderMaintenance = async () => {
    try {
      const response = await fetchMaintenance()
      const status = response.data?.payload?.status
      useCache().maintenance = status === 'ENABLED'
    } catch (err) {
      console.warn('[checkIfUnderMaintenance] Falha ao verificar status de manutenção:', err)
      return false
    }
  }

  return { checkForNewVersion, checkIfUnderMaintenance }
}
